import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import useShopStore from "../store/useShopStore";
import useUserAddressStore from "../store/useUserAddressStore";
import AddressGateModal from "./AddressGateModal";

const PinIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path d="M12 22s7-5.5 7-12a7 7 0 1 0-14 0c0 6.5 7 12 7 12z" fill="none" stroke="currentColor" strokeWidth="1.6"/>
    <circle cx="12" cy="10" r="2.4" fill="currentColor"/>
  </svg>
);

const UserIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <path d="M12.16 10.87c-2.71-.09-4.6-2.06-4.6-4.43A3.56 3.56 0 0 1 12 2a3.56 3.56 0 0 1 4.44 4.44c-.01 2.37-1.9 4.34-4.28 4.43Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7.16 14.56c-2.42 1.62-2.42 4.26 0 5.87 2.75 1.84 7.26 1.84 10.01 0 2.42-1.61 2.42-4.25 0-5.87-2.74-1.83-7.25-1.83-10.01 0Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default function Header() {
  const [gateOpen, setGateOpen] = useState(false);
  const short = useUserAddressStore((s) => s.short);
  const shop  = useShopStore((s) => s.shop);

  const raw = short || shop?.storeAddress?.address || "Ustaw adres dostawy";
  const display = raw.length > 40 ? raw.slice(0, 40) + "…" : raw;

  return (
    <header className="hx">
      <div className="hx__container">
        {/* Left: brand */}
        <Link to="/" className="hx__brand">
          <span className="hx__brand-lun">Lun</span>
          <span className="hx__brand-go">GO</span>
        </Link>

        {/* Center: address (ghost button) */}
        <button className="hx__chip" onClick={() => setGateOpen(true)} aria-haspopup="dialog">
          <span className="hx__chip-icon" aria-hidden="true"><PinIcon/></span>
          <span className="hx__chip-text" title={raw}>{display}</span>
          <span className="hx__caret" aria-hidden="true">▾</span>
        </button>

        {/* Right: profile (icon only) */}
        <Link to="/profile" className="hx__iconbtn" aria-label="Profil">
          <UserIcon/>
        </Link>
      </div>

      {gateOpen && (
        <AddressGateModal
          isOpen={gateOpen}
          onClose={() => setGateOpen(false)}
          onPassed={() => setGateOpen(false)}
        />
      )}
    </header>
  );
}
